import { userEnv } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';


/**
 * 是否支持H5唤起微信服务号订阅组件
 // weixin sdk版本： Android 7.0.15 & IOS 7.0.14
 小程序内嵌H5不支持
 */
export function isSupportWxSubscribe() {
  //  开放标签对系统版本要求： iOS 10.3及以上、Android 5.0及以上
  const isOsSupported = userEnv.isOSVerLargeOrEqualThan({
    android: '5.0',
    iphone: '10.3',
  });
  const androidSupportSDK = '7.0.15';
  const iosSupportSDK = '7.0.14';
  const isInMin = userEnv.isInMiniProgram();
  const { type } = userEnv.getOSInfoObj();
  const isSdkVersionSupported = (type === 'iphone' && userEnv.isWexinVerLargeOrEqualThan(iosSupportSDK)) || (type === 'android' && userEnv.isWexinVerLargeOrEqualThan(androidSupportSDK));
  return isOsSupported && isSdkVersionSupported && !isInMin;
}

/**
 * 用于订阅组件success回调的处理
 * 由于无法区分点了”是“或者”否“，只能针对回调的返回进行过滤，看是否有大于等于一条模板为‘accept’状态
 */
export const checkHasOneAcceptSubscribe = (res) => {
  let hasAccept = false;
  try {
    if (res && /ok/.test(res.errMsg || '')) {
      const subscribeDetails = JSON.parse((res?.subscribeDetails || ''));
      Object.keys(subscribeDetails).forEach((key) => {
        const detailItem = JSON.parse(subscribeDetails[key] || '');
        if (key && detailItem?.status === 'accept') {
          hasAccept = true;
        }
      });
    }
  } catch (e) {
    new CustomException(e, 'handleSubscribeResException', JSON.stringify(res));
  }
  return hasAccept;
};

/**
 * 获得“确定”订阅的模板id列表
 */
export const getAcceptTemplates = (res): string[] => {
  console.log('=====getAcceptTemplates', res);
  const acceptTemplateIds: string[] = [];
  try {
    if (res && /ok/.test(res.errMsg || '')) {
      const subscribeDetails = JSON.parse(res?.subscribeDetails || '');
      Object.keys(subscribeDetails).forEach((key) => {
        const detailItem = JSON.parse(subscribeDetails[key] || '');
        if (key && detailItem?.status === 'accept') {
          acceptTemplateIds.push(key);
        }
      });
    }
  } catch (e) {
    new CustomException(e, 'handleSubscribeResException', JSON.stringify(res));
  }
  return acceptTemplateIds;
};
